module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-200-light-italic-5707ec7d3d0c633b6d23a4aada727fd1.woff";